import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDTO } from '../../types/apiType';
import { BookAuthorized, UserAuthorized } from '../../../views/user-management/components/table/types';

export interface UserState {
  currentUser: UserDTO | null;
  authorizedUsers: UserAuthorized[];
  authorizedBooks: BookAuthorized[];
  selectedUserId: string;
  selectedBookId: string;
  deleteData: any;
}

const initialState: UserState = {
  currentUser: null,
  authorizedUsers: [],
  authorizedBooks: [],
  selectedUserId: '',
  selectedBookId: '',
  deleteData: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<UserDTO>) => {
      state.currentUser = { ...action.payload };
    },
    setAuthorizedUsers: (state, action: PayloadAction<UserAuthorized[]>) => {
      state.authorizedUsers = [...action.payload];
    },
    setAuthorizedBooks: (state, action: PayloadAction<BookAuthorized[]>) => {
      state.authorizedBooks = [...action.payload];
    },
    setSelectedUserId: (state, action: PayloadAction<string>) => {
      state.selectedUserId = action.payload;
    },
    setSelectedBookId: (state, action: PayloadAction<string>) => {
      state.selectedBookId = action.payload;
    },
    setDeleteData: (state, action: PayloadAction<any>) => {
      state.deleteData = action.payload;
    },
  },
});

export const { setCurrentUser, setAuthorizedUsers, setSelectedUserId, setSelectedBookId, setAuthorizedBooks, setDeleteData } =
  userSlice.actions;

export default userSlice.reducer;
